import TicketQuantitySelector, { buildOptions } from './TicketQuantitySelector';

export { buildOptions };
export default TicketQuantitySelector;
